// extracted by mini-css-extract-plugin
module.exports = {"Skill":"Skill_Skill__KebCl","Chart":"Skill_Chart__1w7ix"};